module.exports = __webpack_public_path__ + "img/gallery-pic04.a823568f.jpg";